export default [
  {
    path: '/apps/board',
    name: 'all-tickets',
    component: () => import(/* webpackChunkName: "all-tickets" */ '@/pages/tickets/TicketsPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/tickets/:id',
    name: 'ticket-detail',
    component: () => import(/* webpackChunkName: "ticket-detail" */ '@/pages/tickets/TicketDetailPage.vue'),
    meta: { requiresAuth: true }
  },
  { path: '/kanban', redirect: '/apps/board' },
  { path: '/kanban/reload', redirect: '/apps/board' },
]
